import { defineMessages } from 'react-intl';

export default defineMessages({
  thirtyDaysAverage: { defaultMessage: '30 D.' },
  thirtyDaysAverageFull: { defaultMessage: 'The 30 days average' },
});
